import { render, staticRenderFns } from "./releaseMess.vue?vue&type=template&id=423eda34"
import script from "./releaseMess.vue?vue&type=script&lang=js"
export * from "./releaseMess.vue?vue&type=script&lang=js"
import style0 from "./releaseMess.vue?vue&type=style&index=0&id=423eda34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports